// AdsTableList.jsx
import React, { useState } from "react";
import { useTable, useSortBy, useResizeColumns, useFlexLayout } from "react-table";

import s from "./ads_styles/AdsSearch.module.css";

export default function AdsTableList({
  ads,
  selectedAds = [],
  setSelectedAds = () => {},
  onRowClick, // опционально
}) {
  const [selectAll, setSelectAll] = useState(false);

  const toggleSelectAll = () => {
    if (selectAll) {
      setSelectedAds([]);
    } else {
      setSelectedAds(ads); // сохраняем полный объект
    }
    setSelectAll(!selectAll);
  };

  const toggleSelectOne = (ad) => {
    if (selectedAds.some((a) => a.fiveads_id === ad.fiveads_id)) {
      setSelectedAds(selectedAds.filter((a) => a.fiveads_id !== ad.fiveads_id));
    } else {
      setSelectedAds([...selectedAds, ad]);
    }
  };

  const data = React.useMemo(() => ads, [ads]);

  const columns = React.useMemo(
    () => [
      {
        Header: (
          <input type="checkbox" checked={selectAll} onChange={toggleSelectAll} />
        ),
        accessor: "select",
        width: 40,
        Cell: ({ row }) => {
          const isChecked = selectedAds.some(
            (a) => a.fiveads_id === row.original.fiveads_id
          );
          return (
            <div
              className={s.selectCell}
              onClick={(e) => {
                e.stopPropagation();
                toggleSelectOne(row.original);
              }}
              style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
            >
              <input
                type="checkbox"
                checked={isChecked}
                onChange={() => toggleSelectOne(row.original)}
                onClick={(e) => e.stopPropagation()}
              />
            </div>
          );
        },
      },
      { Header: "fiveads_ID", accessor: "fiveads_id", width: 60 },
      { Header: "ID загрузки", accessor: "ad_id", width: 160 },
      { Header: "Avito ID", accessor: "avito_id", width: 120 },
      {
        Header: "Статус",
        accessor: (row) => (row.active ? "В xml" : "скрыто"),
        id: "active",
        width: 50,
      },
            {
        Header: "Категория",
        id: "category",
        accessor: (row) => row?.Category || row?.category || "",
        width: 130,
        Cell: ({ value }) => (
          <span
            title={value || ""}
            style={{
              display: "inline-block",
              maxWidth: 480,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {value || "-"}
          </span>
        ),
      },
      
      {
        Header: "Заголовок",
        id: "title",
        accessor: (row) => row?.Title || row?.title || "",
        width: 500,
        Cell: ({ value }) => (
          <span
            title={value || ""}
            style={{
              display: "inline-block",
              maxWidth: 480,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {value || "-"}
          </span>
        ),
      },
      {
        Header: "Обновлено",
        accessor: "last_updated",
        width: 100,
        Cell: ({ value }) => {
          if (!value) return "-";
          // Бэкенд отдаёт ISO-строку — приведём к локали
          const d = new Date(value);
          return isNaN(d.getTime()) ? value : d.toLocaleString();
        },
      },
    ],
    [selectAll, selectedAds]
  );

  const defaultColumn = React.useMemo(
    () => ({
      minWidth: 30,
      width: 150,
      maxWidth: 600,
    }),
    []
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data, defaultColumn }, useSortBy, useFlexLayout, useResizeColumns);

  if (!ads || ads.length === 0) return <p>Нет результатов</p>;

  return (
    <div className={s.tableWrapper} {...getTableProps()}>
      <div>
        {headerGroups.map((headerGroup) => (
          <div
            {...headerGroup.getHeaderGroupProps()}
            className={s.tr + " " + s.headerRow}
          >
            {headerGroup.headers.map((column) => (
              <div
                {...column.getHeaderProps(
                  column.id === "select" ? undefined : column.getSortByToggleProps()
                )}
                className={s.th}
              >
                {column.render("Header")}
                <span>
                  {column.isSorted ? (column.isSortedDesc ? " 🔽" : " 🔼") : ""}
                </span>
                <div {...column.getResizerProps()} className={s.resizer} />
              </div>
            ))}
          </div>
        ))}
      </div>

      <div {...getTableBodyProps()}>
        {rows.map((row) => {
          prepareRow(row);
          const isActive = !!row.original.active;
          return (
            <div
              {...row.getRowProps()}
              className={`${s.tr} ${isActive ? "" : s.rowdeactive}`}
              onClick={() =>
                onRowClick ? onRowClick(row.original) : null
              }
            >
              {row.cells.map((cell) => (
                <div {...cell.getCellProps()} className={s.td}>
                  {cell.render("Cell")}
                </div>
              ))}
            </div>
          );
        })}
      </div>
    </div>
  );
}
